import React from 'react';
import { createStyles, WithStyles, withStyles } from '@material-ui/core';

import { CommentForm } from './forms/CommentForm';
import { Submission } from '../shared/types/Submission';
import { Comment } from '../shared/types/Comment';

const styles = () =>
  createStyles({
    root: {
      marginTop: 10,
    },
  });

type Props = WithStyles<typeof styles> & {
  submissionId: Submission['id'];
  initValues?: Comment;
  onSaved: () => void;
};

const AddCommentComponent: React.FunctionComponent<Props> = ({ classes, submissionId, initValues, onSaved }) => {
  return (
    <div className={classes.root}>
      <CommentForm
        submissionId={submissionId}
        initValues={initValues}
        onSaved={onSaved}
      />
    </div>
  );
};

export const AddComment = withStyles(styles)(AddCommentComponent);
